import { Button } from "@/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { cn } from "@/lib/utils";

import { AwardsIcon } from "./icons";

export interface AwardType {
  category?: {
    source?: {
      sourceName: string;
    };
  };
  displayTitle?: string;
  id: string;
}

interface AwardsListProps {
  awards: AwardType[];
  className?: string;
}

function AwardsList({ awards, className }: AwardsListProps) {
  return (
    <>
      {awards.map((award) => {
        const title = award?.displayTitle;
        const source = award?.category?.source?.sourceName;

        if (!title) {
          return null;
        }

        return (
          <div className="flex items-center gap-2" key={award.id}>
            <AwardsIcon />
            <p className={cn("text-apricot text-sm", className)}>
              {title}
              {source && (
                <span className="text-slate-blue">{` - ${source}`}</span>
              )}
            </p>
          </div>
        );
      })}
    </>
  );
}

interface AwardsPopoverProps {
  awards: AwardType[];
  children: React.ReactNode;
}

export default function AwardsPopover({
  awards,
  children,
}: AwardsPopoverProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild>{children}</HoverCardTrigger>
      <HoverCardContent
        className="flex flex-col gap-4 bg-midnight-navy p-2"
        side="top"
      >
        <AwardsList awards={awards.slice(0, 5)} />
        {awards.length > 5 && (
          <div className="flex items-center gap-2 border-slate-blue border-t">
            <AwardsIcon />
            <Button className="text-apricot text-sm" variant="link">
              {awards.length - 5} more award{awards.length - 5 > 1 ? "s" : ""}
            </Button>
          </div>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}
